import { Box } from "@outschool/backpack";
import { ContentfulTutoringPageQuery } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { VisualLinkGrid } from "@outschool/ui-components-website";
import React from "react";

import PageSectionTitle from "./PageSectionTitle";

const TutoringForEveryAge = ({
  visualLinkGridsCollectionItem
}: {
  // @ts-ignore TS(2339): Property 'items' does not exist on type '{ __typen... Remove this comment to see the full error message
  visualLinkGridsCollectionItem: ContentfulTutoringPageQuery["contentfulTutoringPageCollection"]["items"][number]["visualLinkGridsCollection"]["items"][number];
}) => {
  const { t } = useTranslation(
    "client\\components\\tutoring\\TutoringPage\\TutoringForEveryAge"
  );

  // Empty title here, as we don't want to show the title from contentful for this section
  const linkGridWithoutTitle = {
    ...visualLinkGridsCollectionItem,
    title: ""
  } as typeof visualLinkGridsCollectionItem;

  return (
    <Box>
      <PageSectionTitle
        title={t("Find 1-on-1 tutoring for every age")}
        sx={{ paddingBottom: "0" }}
      />

      <Box
        sx={{
          "& > *": { padding: "0 !important" }
        }}
      >
        <VisualLinkGrid item={linkGridWithoutTitle} />{" "}
      </Box>
    </Box>
  );
};

export default TutoringForEveryAge;
